module.exports = __webpack_public_path__ + "static/media/question.332e6698.png";